import { useScrollPosition } from "@/hooks";
import { ArrowUpIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";

const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth",
    });
};

const ScrollToTopButton = () => {
    const [, verticalScrollPosition] = useScrollPosition();

    return (
        <div
            className={clsx([
                "fixed bottom-0 right-0",
                "m-5 z-50",
                "transition-opacity duration-500",
                verticalScrollPosition > 50 ? "opacity-100" : "opacity-0",
            ])}
        >
            <span
                className="flex items-center justify-center w-12 h-12 bg-primary-500 hover:bg-primary-600 rounded-full cursor-pointer"
                onClick={scrollToTop}
            >
                <ArrowUpIcon className="w-6 h-6 text-white" />
            </span>
        </div>
    );
};

export default ScrollToTopButton;
